export default __webpack_public_path__ + "static/media/logo.75b73a58.svg";